import script from "./VisualizadorDocumentoUnico.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizadorDocumentoUnico.vue?vue&type=script&setup=true&lang=js"

import "./VisualizadorDocumentoUnico.vue?vue&type=style&index=0&id=a5104404&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5104404"]])

export default __exports__